module.exports = __webpack_public_path__ + "static/img/icon-bindEmail.2d116c75.png";